import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyCardModule as MatCardModule } from "@angular/material/legacy-card";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from "@angular/material/legacy-progress-spinner";
import { MatLegacyRadioModule as MatRadioModule } from "@angular/material/legacy-radio";
import { DialogLayoutModule, MatCoreModule } from "@obg/mat.ui.core";
import { CoreModule } from "@obg/ngx.core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { GlobalModule } from "@obg/ngx.global";
import { CommonValidationRendererModule, InputInformationModule } from "@obg/ngx.ui.common";
import { CoreUiModule } from "@obg/ngx.ui.core";
import { GlobalUiModule } from "@obg/ngx.ui.global";

import { ZhhLogoutCooldownContainer } from "../../src/logout-cooldown/zhh/zhh-logout-cooldown.container";

const DIRECTIVES: any[] = [ZhhLogoutCooldownContainer];

@NgModule({
	imports: [
		CoreUiModule,
		MatInputModule,
		MatCardModule,
		MatRadioModule,
		GlobalUiModule,
		GlobalModule,
		MatFormFieldModule,
		CommonModule,
		CoreContentModule,
		CoreModule,
		MatCoreModule,
		MatButtonModule,
		MatProgressSpinnerModule,
		ReactiveFormsModule,
		DialogLayoutModule,
		CommonValidationRendererModule,
		InputInformationModule,
	],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class LogoutCooldownModule {
	constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

	getComponent() {
		return this.componentFactoryResolver.resolveComponentFactory(ZhhLogoutCooldownContainer);
	}
}
